const authSteps = {
  PHONE: 'phone',
  PASSWORD: 'password'
};

export default authSteps;
